"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppErrorBoundary = void 0;
var React = require("react");
var Error_1 = require("./Globals/Views/Error");
var AppErrorBoundary = /** @class */ (function (_super) {
    __extends(AppErrorBoundary, _super);
    function AppErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false, error: "" };
        return _this;
    }
    AppErrorBoundary.getDerivedStateFromError = function (error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error: error.toString() };
    };
    AppErrorBoundary.prototype.componentDidCatch = function (error, info) {
        //this.setError(error.toString());
        console.log("Error => " + error.toString());
    };
    AppErrorBoundary.prototype.render = function () {
        if (this.state.hasError) {
            return React.createElement(Error_1.Error, { supportEmail: "support@shoothill.com", error: this.state.error });
        }
        return this.props.children;
    };
    return AppErrorBoundary;
}(React.Component));
exports.AppErrorBoundary = AppErrorBoundary;
//# sourceMappingURL=AppErrorBoundary.js.map